export enum IntakeCompletionStatuses {
  Unopened = 1,
  Incomplete,
  Complete,
}
